
export function convertMinsToHrsMins(mins) {
    let h = Math.floor(mins / 60);
    let m = mins % 60;
    if (m === 0 && h === 0) {
        return '0';
    } else if (m === 0 && h !== 0) {
        return `${h}`;
    } else {
        m = m < 10 ? '0' + m : m;
        return `${h}:${m}`;
    }
}

export function convertMinuteOfUtcDayToTime(minList) {
    let times = [];
    for (const mins of minList) {
        const h = Math.floor(mins / 60).toString().padStart(2, "0");
        const m = (mins % 60).toString().padStart(2, "0");
        times.push(`${h}:${m}Z`)
    }
    return times.join(", ");
}


// WEBPACK FOOTER //
// ./src/utils/dateTime.js